import { toRefs, reactive, computed } from 'vue'
import isPlainObject from 'lodash/isPlainObject'

export default function (rootValue, params = {}) {
  params = Object.assign({
    multiple: false,
    placeholder: '',
    id: '',
    value: '',
    label: '',
    multipleLabelMax: 2,
    labelDelimiter: ', ',
    onChange () {},
    onOpen () {},
    onClose () {},
  }, params)
  
  if (params.multiple && !Array.isArray(rootValue)) {
    throw new Error('A select with multiple values allowed should have `rootValue` as Array')
  }

  const state = reactive({
    value: rootValue,
    focus: false,
    labelHeader: computed(() => getLabel(state.value) || params.placeholder),
    hasValue: computed(() => getLabel(state.value)),
  })

  function updateValue (newValue) {
    state.value = newValue
  }

  function getId (value) {
    return isPlainObject(value) && params.id ? value[params.id] : value
  }

  function getValue (value) {
    return isPlainObject(value) && params.value ? value[params.value] : value
  }

  function getLabel (value) {
    return isPlainObject(value) && params.label 
      ? value[params.label] 
      : Array.isArray(value) 
        ? value
            .map(item => { 
              return getLabel(item)
            })
            .slice(0, params.multipleLabelMax)
            .join(params.labelDelimiter)
        : value 
  }

  function isSelected (option) {
    return params.multiple 
      ? state.value.some(value => 
          params.id ? getId(value) == getId(option) : getValue(value) == getValue(option)
        )
      : getValue(state.value) == getValue(option)
  }

  function select (option) {
    if (params.multiple) {
      let newValue = [...state.value]

      if (isSelected(option)) {
        newValue = newValue.filter(value => 
          params.id ? getId(value) != getId(option) : getValue(value) != getValue(option)
        )          
      } else {
        newValue.push(getValue(option))
      }

      state.value = newValue
      params.onChange && params.onChange(newValue)
    } else {
      let newValue = getValue(option)

      state.value = newValue
      params.onChange && params.onChange(newValue)

      state.focus = false
    }
  } 

  function clear () {
    let newValue = ''

    if (Array.isArray(state.value)) {
      newValue = []
    } else if (isPlainObject(state.value)) {
      newValue = null
    }

    close()

    state.value = newValue
    params.onChange && params.onChange(newValue)
  }

  function open () {
    state.focus = true 

    params.onOpen && params.onOpen()
  }

  function close () {
    state.focus = false

    params.onClose && params.onClose()
  }

  function toggle () {
    state.focus ? close() : open()

    params.onToggle && params.onToggle()
  }

  return {
    ...toRefs(state),
    select,
    toggle,
    open,
    close,
    clear,
    isSelected,
    getId,
    getLabel,
    getValue,
    updateValue,
  }
}